import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=9d2fa362&scoped=true&"
import script from "./forgot.vue?vue&type=script&lang=js&"
export * from "./forgot.vue?vue&type=script&lang=js&"
import style0 from "./forgot.vue?vue&type=style&index=0&id=9d2fa362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2fa362",
  null
  
)

export default component.exports